module.exports = __webpack_public_path__ + "img/breath.690cd831.svg";